import { Component, inject, computed } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { AuthService } from '../../../services/auth.service';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslocoPipe, ProfileMenuComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  protected readonly authService = inject(AuthService);

  readonly isCoach = computed(() => this.authService.userProfile()?.role === 'coach');

  readonly profileInitial = computed(() => {
    const user = this.authService.currentUser();
    const name = user?.displayName ?? user?.email ?? '';
    return name.charAt(0).toUpperCase();
  });
}
